import { persist } from 'zustand/middleware';

import { createStore } from '@store/createStore';

const filterInitialState = {
  causeCategory: { value: 'all', label: 'All' },
  type: { value: 'all', label: 'All' },
  searchValue: '',
  timeUpdatedRange: {
    minTimeUpdated: undefined,
    maxTimeUpdated: undefined,
  },
  timeCreatedReportRange: {
    minTimeCreated: undefined,
    maxTimeCreated: undefined,
  },
  costAvoidedRange: {
    minCostAvoided: undefined,
    maxCostAvoided: undefined,
  },
  sorting: {
    id: '',
    desc: false,
  },
};

const useArchiveFiltersStore = createStore(
  persist(
    (set) => ({
      ...filterInitialState,

      actions: {
        setArchiveFiltersKey: (key, value) => set({ [key]: value }),
        setArchiveFiltersInitial: () => set({ ...filterInitialState }),
      },
    }),
    {
      version: 2,
      name: 'archive-filters',
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) => key !== 'actions' && key !== 'searchValue' && key !== 'sorting',
          ),
        ),
    },
  ),
  'ArchiveInitialStore',
);

export const useArchiveFiltersActions = () => useArchiveFiltersStore((state) => state.actions);

export const selectArchiveFiltersData = () =>
  useArchiveFiltersStore((state) => {
    return {
      timeUpdatedRange: state.timeUpdatedRange,
      timeCreatedReportRange: state.timeCreatedReportRange,
      causeCategory: state.causeCategory,
      type: state.type,
      searchValue: state.searchValue,
      costAvoidedRange: state.costAvoidedRange,
      sorting: state.sorting,
    };
  });
